<template>
  <component
    :is="tag"
    class="form-section-question"
    :style="{
      '--size': `${size}px`,
      '--color': `var(--v-navy-${color}-base)`,
    }"
  >
    <slot />
  </component>
</template>

<script>
export default {
  name: 'form-section-question',
  props: {
    tag: {
      type: String,
      default: 'div',
      validator (value) {
        return ['label', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'div', 'p'].includes(value);
      },
    },
    size: {
      type: [String, Number],
      default: 18,
    },
    color: {
      type: String,
      default: 'medium',
      validator (value) {
        return ['dark', 'medium', 'light'].includes(value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.form-section-question {
  $fzlh_ratio: 24 / 18;

  font-size: var(--size, 18px);
  line-height: #{$fzlh_ratio};
  font-weight: var(--font-2-weight, 600);
  font-family: var(--font-2);
  color: var(--color, $clr-navy-medium);

  &::v-deep {
    & + * { margin-top: 23px; }
  }
}
</style>
